import { render, staticRenderFns } from "./BroadcastDetail.vue?vue&type=template&id=2a7eb928&"
import script from "./BroadcastDetail.vue?vue&type=script&lang=js&"
export * from "./BroadcastDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports